// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../sfd-v2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../sfd-v2/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../sfd-v2/node_modules/css-loader/dist/cjs.js!../theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.epx-dmn-scope {
  width: 260px;
  min-width: 220px;
  max-width: 320px;
  padding: 14px 12px;
  box-sizing: border-box;
  border-left: 1px solid var(--epx-dmn-panel-border);
  background: var(--epx-dmn-panel-hover);
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  color: var(--epx-dmn-panel-text);
  overflow: auto;
  flex-shrink: 0;
}

.epx-dmn-scope__header {
  font-weight: 600;
  font-size: 13px;
  color: var(--epx-dmn-panel-text);
  margin-bottom: 12px;
  letter-spacing: 0.2px;
}

.epx-dmn-scope__empty {
  color: var(--epx-dmn-panel-text-faint);
  font-style: italic;
  padding: 6px 2px;
  line-height: 1.4;
}

.epx-dmn-scope__section {
  margin-bottom: 14px;
}

.epx-dmn-scope__section-head {
  font-size: 10.5px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: var(--epx-dmn-panel-text-muted);
  margin-bottom: 6px;
  font-weight: 600;
}

.epx-dmn-scope__chip {
  display: block;
  padding: 5px 9px;
  border-radius: 10px;
  background: var(--epx-dmn-panel-bg);
  border: 1px solid var(--epx-dmn-panel-border);
  margin: 0 0 6px 0;
  font-size: 12px;
  color: var(--epx-dmn-panel-text);
  cursor: default;
  user-select: none;
}

.epx-dmn-scope__chip-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.epx-dmn-scope__chip-name {
  font-weight: 600;
  word-break: break-word;
}

.epx-dmn-scope__chip-type {
  margin-left: auto;
  font-size: 10.5px;
  padding: 1px 6px;
  border-radius: 6px;
  background: var(--epx-dmn-grid-header-bg);
  color: var(--epx-dmn-panel-text-muted);
  font-family: "Menlo", "Consolas", "Courier New", monospace;
  white-space: nowrap;
}
select.epx-dmn-scope__chip-type--editable {
  border: 1px solid var(--epx-dmn-panel-border, #cbd5e1);
  cursor: pointer;
  appearance: auto;
  -webkit-appearance: auto;
  height: 20px;
  padding: 0 4px;
}
select.epx-dmn-scope__chip-type--editable:hover {
  background: var(--epx-dmn-panel-bg);
}

.epx-dmn-scope__chip-parens {
  color: var(--epx-dmn-panel-text-muted);
  font-family: "Menlo", "Consolas", "Courier New", monospace;
  font-size: 11px;
}

.epx-dmn-scope__chip-source {
  font-size: 10.5px;
  color: var(--epx-dmn-panel-text-faint);
  margin-top: 3px;
}

.epx-dmn-scope__chip--input {
  border-color: var(--epx-dmn-input-stroke);
  background: var(--epx-dmn-input-fill);
}
.epx-dmn-scope__chip--decision {
  border-color: var(--epx-dmn-decision-stroke);
  background: var(--epx-dmn-decision-fill);
}
.epx-dmn-scope__chip--function {
  border-color: var(--epx-dmn-bkm-stroke);
  background: var(--epx-dmn-bkm-fill);
}
.epx-dmn-scope__chip--param {
  border-color: var(--epx-dmn-ks-stroke);
  background: var(--epx-dmn-ks-fill);
}
.epx-dmn-scope__chip--self {
  border-style: dashed;
  opacity: 0.85;
}

.epx-dmn-scope__section-head--orphan {
  color: var(--epx-dmn-error-text);
  display: flex;
  align-items: center;
  gap: 6px;
}
.epx-dmn-scope__orphan-count {
  margin-left: auto;
  background: var(--epx-dmn-error-bg);
  color: var(--epx-dmn-error-text);
  border: 1px solid var(--epx-dmn-error-border);
  border-radius: 8px;
  padding: 0 7px;
  font-size: 10px;
  letter-spacing: 0.4px;
  min-width: 18px;
  text-align: center;
}
.epx-dmn-scope__section--orphans:has(.epx-dmn-scope__orphan-empty) .epx-dmn-scope__orphan-count {
  background: var(--epx-dmn-grid-header-bg);
  color: var(--epx-dmn-panel-text-faint);
  border-color: var(--epx-dmn-panel-border);
}
.epx-dmn-scope__orphan-empty {
  font-size: 10.5px;
  color: var(--epx-dmn-panel-text-faint);
  font-style: italic;
  padding: 2px 2px 4px;
  line-height: 1.4;
}
.epx-dmn-scope__chip--orphan {
  border-color: var(--epx-dmn-error-border);
  background: var(--epx-dmn-error-bg);
  color: var(--epx-dmn-error-text);
}
.epx-dmn-scope__orphan-promote {
  margin-left: 6px;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  border: 1px solid var(--epx-dmn-error-border);
  background: var(--epx-dmn-panel-bg);
  color: var(--epx-dmn-error-text);
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.epx-dmn-scope__orphan-promote:hover {
  background: var(--epx-dmn-danger);
  color: var(--epx-dmn-panel-bg);
  border-color: var(--epx-dmn-danger);
}

.epx-dmn-scope__chip--clickable {
  cursor: pointer;
  transition: transform 0.08s ease, box-shadow 0.12s ease;
}
.epx-dmn-scope__chip--clickable:hover {
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.12);
  transform: translateY(-1px);
}
.epx-dmn-scope__chip--clickable:active {
  transform: translateY(0);
  box-shadow: none;
}

/* ── Builtins (FEEL functions) ───────────────────────────────────────── */
.epx-dmn-scope__section--builtins {
  margin-top: 6px;
  border-top: 1px solid var(--epx-dmn-panel-border);
  padding-top: 10px;
}
.epx-dmn-scope__builtins-head {
  all: unset;
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  cursor: pointer;
  padding: 4px 2px;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: var(--epx-dmn-panel-text-muted);
  font-weight: 600;
  border-radius: 4px;
}
.epx-dmn-scope__builtins-head:hover {
  background: var(--epx-dmn-panel-hover);
  color: var(--epx-dmn-panel-text);
}
.epx-dmn-scope__builtins-arrow {
  display: inline-block;
  width: 10px;
  font-size: 10px;
  color: var(--epx-dmn-panel-text-muted);
}
.epx-dmn-scope__builtins-count {
  margin-left: auto;
  background: var(--epx-dmn-grid-header-bg);
  color: var(--epx-dmn-panel-text-muted);
  border-radius: 8px;
  padding: 1px 7px;
  font-size: 10px;
  letter-spacing: 0.4px;
}
.epx-dmn-scope__builtins-cat {
  margin: 8px 0 4px;
}
.epx-dmn-scope__builtins-cat-head {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--epx-dmn-panel-text-faint);
  margin: 6px 0 4px;
}
.epx-dmn-scope__builtin {
  display: block;
  padding: 4px 8px;
  margin-bottom: 4px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: var(--epx-dmn-panel-bg);
  font-family: "Menlo", "Consolas", "Courier New", monospace;
  font-size: 11.5px;
  cursor: pointer;
  transition: background 0.08s ease, border-color 0.08s ease;
}
.epx-dmn-scope__builtin:hover {
  border-color: var(--epx-dmn-bkm-stroke);
  background: var(--epx-dmn-bkm-fill);
}
.epx-dmn-scope__builtin-name {
  color: var(--epx-dmn-bkm-stroke);
  font-weight: 600;
}
.epx-dmn-scope__builtin-sig {
  color: var(--epx-dmn-panel-text-muted);
}
.epx-dmn-scope__builtin-desc {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 10.5px;
  color: var(--epx-dmn-panel-text-faint);
  margin-top: 2px;
  line-height: 1.3;
}
`, "",{"version":3,"sources":["webpack://./../epx-dmn/src/scope/styles.css"],"names":[],"mappings":"AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,kDAAkD;EAClD,sCAAsC;EACtC,2DAA2D;EAC3D,eAAe;EACf,gCAAgC;EAChC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;EACnC,6CAA6C;EAC7C,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,sCAAsC;EACtC,0DAA0D;EAC1D,mBAAmB;AACrB;AACA;EACE,sDAAsD;EACtD,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;EACtC,0DAA0D;EAC1D,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;AACvC;AACA;EACE,4CAA4C;EAC5C,wCAAwC;AAC1C;AACA;EACE,uCAAuC;EACvC,mCAAmC;AACrC;AACA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;AACA;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,gCAAgC;EAChC,6CAA6C;EAC7C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,yCAAyC;EACzC,sCAAsC;EACtC,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,yCAAyC;EACzC,mCAAmC;EACnC,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;EAC7C,mCAAmC;EACnC,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,uDAAuD;AACzD;AACA;EACE,4CAA4C;EAC5C,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E;EACE,eAAe;EACf,iDAAiD;EACjD,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sCAAsC;EACtC,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,sCAAsC;EACtC,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,mCAAmC;EACnC,0DAA0D;EAC1D,iBAAiB;EACjB,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,uCAAuC;EACvC,mCAAmC;AACrC;AACA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,2DAA2D;EAC3D,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["@import url('../theme.css');\n\n.epx-dmn-scope {\n  width: 260px;\n  min-width: 220px;\n  max-width: 320px;\n  padding: 14px 12px;\n  box-sizing: border-box;\n  border-left: 1px solid var(--epx-dmn-panel-border);\n  background: var(--epx-dmn-panel-hover);\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  color: var(--epx-dmn-panel-text);\n  overflow: auto;\n  flex-shrink: 0;\n}\n\n.epx-dmn-scope__header {\n  font-weight: 600;\n  font-size: 13px;\n  color: var(--epx-dmn-panel-text);\n  margin-bottom: 12px;\n  letter-spacing: 0.2px;\n}\n\n.epx-dmn-scope__empty {\n  color: var(--epx-dmn-panel-text-faint);\n  font-style: italic;\n  padding: 6px 2px;\n  line-height: 1.4;\n}\n\n.epx-dmn-scope__section {\n  margin-bottom: 14px;\n}\n\n.epx-dmn-scope__section-head {\n  font-size: 10.5px;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: var(--epx-dmn-panel-text-muted);\n  margin-bottom: 6px;\n  font-weight: 600;\n}\n\n.epx-dmn-scope__chip {\n  display: block;\n  padding: 5px 9px;\n  border-radius: 10px;\n  background: var(--epx-dmn-panel-bg);\n  border: 1px solid var(--epx-dmn-panel-border);\n  margin: 0 0 6px 0;\n  font-size: 12px;\n  color: var(--epx-dmn-panel-text);\n  cursor: default;\n  user-select: none;\n}\n\n.epx-dmn-scope__chip-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.epx-dmn-scope__chip-name {\n  font-weight: 600;\n  word-break: break-word;\n}\n\n.epx-dmn-scope__chip-type {\n  margin-left: auto;\n  font-size: 10.5px;\n  padding: 1px 6px;\n  border-radius: 6px;\n  background: var(--epx-dmn-grid-header-bg);\n  color: var(--epx-dmn-panel-text-muted);\n  font-family: \"Menlo\", \"Consolas\", \"Courier New\", monospace;\n  white-space: nowrap;\n}\nselect.epx-dmn-scope__chip-type--editable {\n  border: 1px solid var(--epx-dmn-panel-border, #cbd5e1);\n  cursor: pointer;\n  appearance: auto;\n  -webkit-appearance: auto;\n  height: 20px;\n  padding: 0 4px;\n}\nselect.epx-dmn-scope__chip-type--editable:hover {\n  background: var(--epx-dmn-panel-bg);\n}\n\n.epx-dmn-scope__chip-parens {\n  color: var(--epx-dmn-panel-text-muted);\n  font-family: \"Menlo\", \"Consolas\", \"Courier New\", monospace;\n  font-size: 11px;\n}\n\n.epx-dmn-scope__chip-source {\n  font-size: 10.5px;\n  color: var(--epx-dmn-panel-text-faint);\n  margin-top: 3px;\n}\n\n.epx-dmn-scope__chip--input {\n  border-color: var(--epx-dmn-input-stroke);\n  background: var(--epx-dmn-input-fill);\n}\n.epx-dmn-scope__chip--decision {\n  border-color: var(--epx-dmn-decision-stroke);\n  background: var(--epx-dmn-decision-fill);\n}\n.epx-dmn-scope__chip--function {\n  border-color: var(--epx-dmn-bkm-stroke);\n  background: var(--epx-dmn-bkm-fill);\n}\n.epx-dmn-scope__chip--param {\n  border-color: var(--epx-dmn-ks-stroke);\n  background: var(--epx-dmn-ks-fill);\n}\n.epx-dmn-scope__chip--self {\n  border-style: dashed;\n  opacity: 0.85;\n}\n\n.epx-dmn-scope__section-head--orphan {\n  color: var(--epx-dmn-error-text);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.epx-dmn-scope__orphan-count {\n  margin-left: auto;\n  background: var(--epx-dmn-error-bg);\n  color: var(--epx-dmn-error-text);\n  border: 1px solid var(--epx-dmn-error-border);\n  border-radius: 8px;\n  padding: 0 7px;\n  font-size: 10px;\n  letter-spacing: 0.4px;\n  min-width: 18px;\n  text-align: center;\n}\n.epx-dmn-scope__section--orphans:has(.epx-dmn-scope__orphan-empty) .epx-dmn-scope__orphan-count {\n  background: var(--epx-dmn-grid-header-bg);\n  color: var(--epx-dmn-panel-text-faint);\n  border-color: var(--epx-dmn-panel-border);\n}\n.epx-dmn-scope__orphan-empty {\n  font-size: 10.5px;\n  color: var(--epx-dmn-panel-text-faint);\n  font-style: italic;\n  padding: 2px 2px 4px;\n  line-height: 1.4;\n}\n.epx-dmn-scope__chip--orphan {\n  border-color: var(--epx-dmn-error-border);\n  background: var(--epx-dmn-error-bg);\n  color: var(--epx-dmn-error-text);\n}\n.epx-dmn-scope__orphan-promote {\n  margin-left: 6px;\n  width: 22px;\n  height: 22px;\n  border-radius: 6px;\n  border: 1px solid var(--epx-dmn-error-border);\n  background: var(--epx-dmn-panel-bg);\n  color: var(--epx-dmn-error-text);\n  font-size: 14px;\n  line-height: 1;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.epx-dmn-scope__orphan-promote:hover {\n  background: var(--epx-dmn-danger);\n  color: var(--epx-dmn-panel-bg);\n  border-color: var(--epx-dmn-danger);\n}\n\n.epx-dmn-scope__chip--clickable {\n  cursor: pointer;\n  transition: transform 0.08s ease, box-shadow 0.12s ease;\n}\n.epx-dmn-scope__chip--clickable:hover {\n  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.12);\n  transform: translateY(-1px);\n}\n.epx-dmn-scope__chip--clickable:active {\n  transform: translateY(0);\n  box-shadow: none;\n}\n\n/* ── Builtins (FEEL functions) ───────────────────────────────────────── */\n.epx-dmn-scope__section--builtins {\n  margin-top: 6px;\n  border-top: 1px solid var(--epx-dmn-panel-border);\n  padding-top: 10px;\n}\n.epx-dmn-scope__builtins-head {\n  all: unset;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  cursor: pointer;\n  padding: 4px 2px;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: var(--epx-dmn-panel-text-muted);\n  font-weight: 600;\n  border-radius: 4px;\n}\n.epx-dmn-scope__builtins-head:hover {\n  background: var(--epx-dmn-panel-hover);\n  color: var(--epx-dmn-panel-text);\n}\n.epx-dmn-scope__builtins-arrow {\n  display: inline-block;\n  width: 10px;\n  font-size: 10px;\n  color: var(--epx-dmn-panel-text-muted);\n}\n.epx-dmn-scope__builtins-count {\n  margin-left: auto;\n  background: var(--epx-dmn-grid-header-bg);\n  color: var(--epx-dmn-panel-text-muted);\n  border-radius: 8px;\n  padding: 1px 7px;\n  font-size: 10px;\n  letter-spacing: 0.4px;\n}\n.epx-dmn-scope__builtins-cat {\n  margin: 8px 0 4px;\n}\n.epx-dmn-scope__builtins-cat-head {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--epx-dmn-panel-text-faint);\n  margin: 6px 0 4px;\n}\n.epx-dmn-scope__builtin {\n  display: block;\n  padding: 4px 8px;\n  margin-bottom: 4px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  background: var(--epx-dmn-panel-bg);\n  font-family: \"Menlo\", \"Consolas\", \"Courier New\", monospace;\n  font-size: 11.5px;\n  cursor: pointer;\n  transition: background 0.08s ease, border-color 0.08s ease;\n}\n.epx-dmn-scope__builtin:hover {\n  border-color: var(--epx-dmn-bkm-stroke);\n  background: var(--epx-dmn-bkm-fill);\n}\n.epx-dmn-scope__builtin-name {\n  color: var(--epx-dmn-bkm-stroke);\n  font-weight: 600;\n}\n.epx-dmn-scope__builtin-sig {\n  color: var(--epx-dmn-panel-text-muted);\n}\n.epx-dmn-scope__builtin-desc {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 10.5px;\n  color: var(--epx-dmn-panel-text-faint);\n  margin-top: 2px;\n  line-height: 1.3;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
